import React from "react";
import { StyledButton } from "./HyroButton.styles";
import { BUTTON_VARIANTS, BUTTON_COLORS, BUTTON_SIZES, ICON_COLOR_MODES } from "@hyro-components/hyro-button/HyroButton.consts";
import Tooltip from "@hyro-components/Tooltip";

const HyroButton = ({
  children,
  tooltip,
  variant = BUTTON_VARIANTS.TEXT,
  color = BUTTON_COLORS.PRIMARY,
  size = BUTTON_SIZES.MEDIUM,
  iconColorMode = ICON_COLOR_MODES.STROKE,
  active = false,
  ...props
}) => {
  const buttonElement = (
    <StyledButton
      variant={variant}
      color={color}
      size={size}
      active={active}
      iconColorMode={iconColorMode}
      {...props}
    >
      {children}
    </StyledButton>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        {buttonElement}
      </Tooltip>
    );
  }

  return buttonElement;
};

export default HyroButton;
